<template>
  <div class="asc-fault-monitor-export">
    <div class="asc-fault-monitor-export--container">
      <div class="asc-fault-monitor-export-options--container">
        <div class="asc-fault-monitor-export-options">
          <asc-date-picker
            v-model="dates"
            label="Dates"
            range-only
            has-icon
            :max="maxDate"
            hide-details
            class="asc-child-options"
            icon-position="right"
            @input="handleInput()"
          ></asc-date-picker>
          <div class="asc-empty-div"></div>
          <asc-autocomplete-selector
            v-model="airlineIds"
            :items="airlinesData"
            label="Airline"
            class="asc-child-options"
            placeholder="Select Airline"
            :component-type="airlinesData.length > 1 ? 'multiple' : 'single'"
            dense
            drop-down-size-matches
            required
            fixed-position
            short
            @input="handleInput()"
          ></asc-autocomplete-selector>
          <div class="asc-empty-div"></div>
        </div>
        <asc-note class="asc-report-note">
          <v-icon class="asc-report-note--icon" :size="12" color="#C98703"
            >mdi-alert</v-icon
          >
          <span class="asc-report-note--text"
            >Note: Selected options will influence the amount of exported data
            and the time to generate the export.</span
          >
        </asc-note>
      </div>
    </div>
  </div>
</template>

<script>
import AscDatePicker from '@/components/atoms/AscDatePicker'
import AscNote from '@/components/atoms/AscNote'
import AscAutocompleteSelector from './AscAutocompleteSelector'
import {
  getDateGivenOffset,
  getReportExportMinDate,
  getReportExportMaxDate,
} from '@/utilities/dates'

export default {
  name: 'AscFaultMonitorExport',

  components: {
    AscDatePicker,
    AscAutocompleteSelector,
    AscNote,
  },

  props: {
    value: {
      type: Object,
      default: null,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      airlineIds:
        this.value && this.value.airlineIds
          ? this.value.airlineIds
          : this.airlines?.length === 1
          ? [this.airlines[0].value]
          : [],
      dates:
        this.value && this.value.dates
          ? this.value.dates
          : {
              startDate: getDateGivenOffset(new Date(), -14),
              endDate: new Date(),
            },
      minDate: getReportExportMinDate(),
      maxDate: getReportExportMaxDate(),
    }
  },

  computed: {
    airlinesData() {
      return this.airlines
    },
  },

  mounted() {
    this.handleInput()
  },

  methods: {
    handleInput() {
      const data = {
        dates: {
          startDate:
            this.dates.startDate !== null ? this.dates.startDate : new Date(),
          endDate:
            this.dates.endDate !== null ? this.dates.endDate : new Date(),
        },
        airlineIds: this.airlineIds,
      }
      this.$emit('input', data)
    },
  },
}
</script>

<style lang="scss">
.asc-fault-monitor-export--container {
  padding: 20px 10px;

  .asc-empty-div {
    height: 30px;
  }

  .asc-report-note {
    &.asc-note--container {
      background-color: $semantic-warning-hover;
    }

    .asc-note {
      display: flex;
    }

    &--icon {
      align-self: flex-start;
      padding: 6px 3px;
    }

    &--text {
      color: $primary-black;
      font-size: 12px;
      padding: 3px;
    }
  }
}
</style>
